import Link from "next/link";
import Image from "next/image";

export default function ListPrestasi({ url, picture, title, time }) {
  return (
    <li className="group col-span-1 w-full cursor-pointer">
      <Link href={`/tentang-kami/prestasi/${url}`}>
        <div className="flex h-full items-center justify-start space-x-3">
          <div className="relative flex h-24 w-24 items-center justify-center">
            <Image
              src={picture ? picture : "/images/berita-awal.png"}
              alt="prestasi"
              className="rounded-lg bg-cover bg-center"
              width={96}
              height={96}
              objectFit="contain"
              priority={true}
            />
          </div>
          <div className="flex h-auto w-full flex-col justify-between pt-10 text-left">
            <p className="hide-text font-nunito text-sm font-bold transition duration-200 ease-out group-hover:translate-x-4 group-hover:drop-shadow-lg lg:text-lg">
              {title}
            </p>
            <div className="mt-2 flex w-full justify-between">
              <p className="font-sans text-xs font-light text-black">
                Posted by : Admin
              </p>
              <p className="font-sans text-xs font-light text-black">
                Created at : {time.split("T")[0]}
              </p>
            </div>
            <hr className="mt-3 h-0.5 w-full bg-[#DAE6F1]" />
          </div>
        </div>
      </Link>
    </li>
  );
}
